var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.resetButtonIsVisible)?_c('div',[_c('a',{staticClass:"resetLink",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.handleReset.apply(null, arguments)}}},[_vm._v("\n        Reset "),_c('span',{staticClass:"s-hide"},[_vm._v("filter")]),_vm._v(" "),_c('i',{staticClass:"fa fa-ban"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }